import { CallCenterRouteOrderListItem } from "api/call-center/routes/models";
import cx from "classnames";
import { InitialsAvatar } from "components/utils/userAvatar/InitialsAvatar";
import styles from "../../shared/CallCenter.module.css";
import faceIcon from "assets/images/face.svg";
import { useRoutePatchMutation } from "api/call-center/routes/hooks";
import { useSelector } from "hooks";
import { Tooltip } from "components/miloDesignSystem/atoms/tooltip";
import { IconButton } from "components/miloDesignSystem/atoms/iconButton";
import { MdiClose } from "components/miloDesignSystem/atoms/icons/MdiClose";

interface Props {
  order: CallCenterRouteOrderListItem;
}

export const ResponsibleForRoute = ({ order }: Props) => {
  const assignResponsibleForRouteMutation = useRoutePatchMutation();
  const me = useSelector(store => store.auth.user!);

  return (
    <div>
      {order.responsible ? (
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            {order.responsible.avatar ? (
              <div className={cx(styles.listAvatar, styles.avatarSmall)}>
                <img alt="avatar" src={order.responsible.avatar} />
              </div>
            ) : (
              <InitialsAvatar
                className={cx(styles.listAvatar, styles.avatarMedium)}
                firstName={order.responsible.firstName}
                lastName={order.responsible.lastName}
                style={{ margin: 0, background: "#00cf91" }}
              />
            )}
            <div className={cx(styles.overflow, "fw-700 ml-1")}>
              {order.responsible.firstName} {order.responsible.lastName}
            </div>
          </div>

          <IconButton
            className={styles.deleteIcon}
            icon={MdiClose}
            variant="white"
            onMouseDown={e => {
              e.stopPropagation();
              assignResponsibleForRouteMutation.mutate({
                id: order.id,
                toUpdate: {
                  responsible: null,
                },
              });
            }}
          />
        </div>
      ) : (
        <Tooltip title="Przydziel do mnie">
          <button
            className={cx(styles.avatar, styles.avatarMedium, styles.avatarPlaceholder)}
            onMouseDown={e => e.stopPropagation()}
            onClick={() => {
              assignResponsibleForRouteMutation.mutate({
                id: order.id,
                toUpdate: {
                  responsible: me,
                },
              });
            }}
          >
            <img alt="Przypisz" src={faceIcon} style={{ height: "18px", width: "18px" }} />
          </button>
        </Tooltip>
      )}
    </div>
  );
};
